import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Input,
  Form,
  Select,
  Row,
  Col,
  Spin,
  Tooltip,
  message
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import UserIcon from "../../../../assets/images/icons/userLogo.svg";
import { useLocation } from "react-router-dom";
import { useStore } from "../../../../store";
import { TAB_KEYS } from "../../../../config";
import { useTab } from "../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../utils";
import ReactPlayer from "react-player/youtube";
import { toast } from "react-toastify";
import { truncateFilename } from "../../../../utils/helper"
import userServiceApi from "../../../../api/userServiceApi";
import { deleteRequest } from "../../../../api/http";
import SynthesiaVideo from "./SynthesiaVideo";

const { TextArea } = Input;
const MAX_CHARACTERS = 700;

export default function ServiceComponent({ dataLoader, form, getSingleTabData, loader: formDataLoader }) {
  const { state } = useLocation();

  const tabKey = state;
  const { tabData } = useStore();
  const whichTab = TAB_KEYS.service;
  const { deleteSingleItem, postLoader } = useTab();
  const { updateImage, updateFile } = useConnectsuForm();
  const [loader, setLoader] = useState(formDataLoader || true);
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();

  // 🔹 New states for controlling Add/Clear
  const [showClear, setShowClear] = useState(false);
  const [clearEnabled, setClearEnabled] = useState(false);
  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);

  useEffect(() => {
    localStorage.setItem("tab", "SERVICE");
  }, []);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  }, [Object.keys(updatedValues).length]);

  const renderMedia = (dataItem) => {
    const commonStyles = {
      width: "350px",
      height: "250px",
      display: "flex",
      justifyContent: "center",
    };

    if (
      dataItem?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className="iframe-comp" style={commonStyles}>
          <ReactPlayer
            controls={true}
            url={dataItem.mediaLink.url}
            width="100%"
            height="100%"
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div style={commonStyles}>
          <iframe
            src={dataItem.mediaLink.url}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            width="100%"
            height="100%"
            style={{ backgroundColor: "black" }}
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "IMAGE" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className="iframe-comp" style={commonStyles}>
          <img
            src={dataItem?.mediaLink?.url}
            alt=""
            className="c1 carousel-image"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      );
    }

    else if (
      dataItem?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
      dataItem.mediaLink.url) {
      return (
        <div>
          <SynthesiaVideo key={dataItem.id} videoData={dataItem} />

        </div>
      )
    }


    return null;
  };

  const findValue = (i, key) => {
    return getFormFieldValue(form, whichTab, i, key);
  };
  const SelectChangeHandler = (e, i) => {
    form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
  };

  const handleDeleteBrochure = async (id) => {
    try {
      const res = await deleteRequest(userServiceApi.deleteBrochure(id))
      if (res) {
        toast.success('Successfully Delete Brochure')
        getSingleTabData(tabKey, form)
      }
    } catch (error) {
      toast.error('Failed to Delete Brochure')
    }
  }

  // ✅ Reusable fresh row template
  const emptyRow = {
    id: undefined,
    title: "",
    description: "",
    mediaLink: { mediaType: undefined, url: "" },
    urlLink: "",
    BrochureFile: null,
    brochureFileName: "",
    brochureFilePath: "",
    media: null,
  };

  // ✅ Handle Add More
  const handleAddMore = () => {
    if (!canAddNew) {
      message.warning("You must save the current item before you can add a new one.");
      return;
    }

    const currentList = form.getFieldValue(whichTab) || [];
    const newList = [emptyRow, ...currentList];

    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);
    setShowClear(true);
    setClearEnabled(true);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Handle Clear
  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const updatedList = currentList.map(item => (!item?.id ? { ...emptyRow } : item));

    form.setFieldsValue({ [whichTab]: updatedList });

    // refreshUnsavedState();

    setShowClear(false);
    setClearEnabled(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabData?.service?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer); // cleanup for safety
  }, [tabData?.service]);

  // ✅ Refresh Unsaved State
  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(item => {
      const hasData =
        item?.title?.trim() ||
        item?.description?.trim() ||
        item?.mediaLink?.url?.trim() ||
        item?.media ||
        item?.BrochureFile;

      return !item?.id && hasData;
    });

    setCanAddNew(!unsavedItem);
    setHasUnsavedItem(!!unsavedItem);
  };

  useEffect(() => {
    form.resetFields();
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [tabData[whichTab]]);


  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div>
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {tabKey === whichTab ? (
            <>
              <Col className="gutter-row tabContent" span={24}>
                <>
                  <Form.List
                    name={whichTab}
                    initialValue={
                      tabData &&
                        tabData[whichTab] &&
                        tabData[whichTab].length > 0
                        ? tabData[whichTab]
                        : [""]
                    }
                  >
                    {(fields, { add, remove }) => (
                      <>
                        <div className="inputBody">
                          <label></label>
                          <div style={{ textAlign: "right" }}>
                            {hasUnsavedItem && (
                              <Button
                                className="cancelBtn"
                                type="button"
                                // disabled={!clearEnabled}
                                onClick={handleClear}
                              >
                                Clear
                              </Button>
                            )}
                            <Button
                              className="greenBtn"
                              onClick={handleAddMore}
                            >
                              Add <PlusOutlined />
                            </Button>
                          </div>
                        </div>

                        {fields.map(({ key, name, ...restField }, i) => (
                          <div className="card-item" key={key}>
                            <Col
                              className="gutter-row tabContent"
                              span={16}
                              style={{ paddingRight: "25px" }}
                            >
                              <div className="d-flex">
                                {/* <Form.Item
                                  {...restField}
                                  className="w-100"
                                  label="Service Name"
                                  name={[name, "title"]}
                                  labelCol={{ span: 5 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Service name is required",
                                    },
                                    {
                                      max: 40,
                                      message: "Title cannot exceed 40 characters",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Service Name"
                                    onChange={() => {
                                      setShowClear(true);
                                      setClearEnabled(true);
                                    }}
                                  />
                                </Form.Item> */}

                                <Form.Item
                                  {...restField}
                                  className="w-100"
                                  label="Service Name"
                                  name={[name, "title"]}
                                  labelCol={{ span: 5 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Service name is required",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Service Name"
                                    maxLength={40}
                                    showCount={{
                                      formatter: ({ count }) => `${count}/40`,
                                    }}
                                    onChange={() => {
                                      setShowClear(true);
                                      setClearEnabled(true);
                                    }}
                                    onKeyDown={(e) => {
                                      const currentValue =
                                        form.getFieldValue([whichTab, name, "title"]) || "";

                                      if (
                                        e.key.length === 1 && // normal characters only
                                        currentValue.length >= 40
                                      ) {
                                        form.setFields([
                                          {
                                            name: [whichTab, name, "title"],
                                            errors: ["Title cannot exceed 40 characters"],
                                          },
                                        ]);
                                      }
                                    }}
                                    onBlur={() => {
                                      form.setFields([
                                        {
                                          name: [whichTab, name, "title"],
                                          errors: [],
                                        },
                                      ]);
                                    }}
                                  />
                                </Form.Item>


                                <Form.Item>
                                  <div className="remove-btn">
                                    <DeleteOutlined
                                      title="Delete News"
                                      onClick={() => {
                                        const id = form.getFieldValue([
                                          whichTab,
                                          i,
                                          "id",
                                        ]);
                                        if (id) {
                                          deleteSingleItem(whichTab, id, form);
                                        } else {
                                          remove(name);
                                          setHasUnsavedItem(false);
                                          refreshUnsavedState();
                                        }
                                      }}
                                    />
                                  </div>
                                </Form.Item>
                              </div>

                              <Form.Item
                                label="Description"
                                {...restField}
                                name={[name, "description"]}
                                labelCol={{ span: 5 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Description is required",
                                  },
                                  {
                                    max: MAX_CHARACTERS - 1,
                                    message: `Description should be less than ${MAX_CHARACTERS} character`,
                                  },
                                ]}
                              >
                                <TextArea
                                  placeholder="Enter Description"
                                  rows={5}
                                  maxLength={MAX_CHARACTERS}
                                  showCount
                                  onChange={() => {
                                    setShowClear(true);
                                    setClearEnabled(true);
                                  }}
                                />
                              </Form.Item>

                              <div className="d-flex">
                                <Form.Item
                                  {...restField}
                                  className="w-100"
                                  name={[name, "mediaLink", "mediaType"]}
                                  label="Video or Image"
                                  labelCol={{ span: 5 }}
                                >
                                  <Select
                                    name={[name, "mediaLink", "mediaType"]}
                                    onChange={(e) => {
                                      SelectChangeHandler(e, i);
                                      setShowClear(true);
                                      setClearEnabled(true);
                                    }}
                                    placeholder="Select Option"
                                  >
                                    <Select.Option value="VIMEO_MEDIA">
                                      Add Vimeo Link
                                    </Select.Option>
                                    <Select.Option value="SOCIAL_MEDIA">
                                      Add Youtube Link
                                    </Select.Option>
                                    <Select.Option value="SYNTHESIA_MEDIA">
                                      Add Synthesia Link
                                    </Select.Option>
                                    <Select.Option value="IMAGE">
                                      Upload Image
                                    </Select.Option>
                                  </Select>
                                </Form.Item>
                                <Form.Item>
                                  <div className="remove-btn">
                                    <Tooltip title="Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio">
                                      <QuestionCircleOutlined />
                                    </Tooltip>
                                  </div>
                                </Form.Item>
                              </div>

                              {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                                <Form.Item
                                  label="Youtube Link"
                                  {...restField}
                                  labelCol={{ span: 5 }}
                                  name={[name, "mediaLink", "url"]}
                                >
                                  <Input
                                    onChange={() => {
                                      setShowClear(true);
                                      setClearEnabled(true);
                                    }}
                                  />
                                </Form.Item>
                              ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                                <Form.Item
                                  label="Vimeo Link"
                                  labelCol={{ span: 5 }}
                                  {...restField}
                                  name={[name, "mediaLink", "url"]}
                                >
                                  <Input
                                    onChange={() => {
                                      setShowClear(true);
                                      setClearEnabled(true);
                                    }}
                                  />
                                </Form.Item>
                              ) : findValue(i, "type") === "IMAGE" ? (
                                <Form.Item
                                  {...restField}
                                  label="Image"
                                  colon={false}
                                  name="media"
                                  className="experienceImg"
                                  labelCol={{ span: 5 }}
                                >
                                  {findValue(i, "blob") ? (
                                    <Avatar
                                      src={URL.createObjectURL(
                                        findValue(i, "blob")
                                      )}
                                    />
                                  ) : findValue(i, "url") ? (
                                    <Avatar src={findValue(i, "url")} />
                                  ) : (
                                    <Avatar src={UserIcon} />
                                  )}
                                  <label
                                    name="file"
                                    className="fileUploadBtn greenBtn"
                                  >
                                    Choose File
                                    <input
                                      accept="image/png, image/gif, image/jpeg"
                                      type="file"
                                      onChange={(e) => {
                                        updateImage(e, i, form, whichTab);
                                        setShowClear(true);
                                        setClearEnabled(true);
                                      }}
                                    />
                                  </label>
                                </Form.Item>
                              ) : findValue(i, "type") === "SYNTHESIA_MEDIA" ? (
                                <Form.Item
                                  label="Synthesia Link"
                                  labelCol={{ span: 5 }}
                                  {...restField}
                                  name={[name, "mediaLink", "url"]}

                                >
                                  <Input />
                                </Form.Item>
                              ) : null}

                              <Form.Item
                                label="External Link"
                                {...restField}
                                className="w-100"
                                name={[name, "urlLink"]}
                                labelCol={{ span: 5 }}
                              >
                                <Input
                                  placeholder="External Link"
                                  onChange={() => {
                                    setShowClear(true);
                                    setClearEnabled(true);
                                  }}
                                />
                              </Form.Item>

                              <div className="d-flex">
                                <Form.Item
                                  {...restField}
                                  label="Brochure"
                                  colon={false}
                                  name={[name, "BrochureFile"]}
                                  className="experienceImg w-100"
                                  labelCol={{ span: 5 }}
                                >
                                  {form.getFieldValue(tabKey)[i]
                                    ?.BrochureFile ? (
                                    truncateFilename(
                                      form.getFieldValue(tabKey)[i]
                                        ?.BrochureFile?.name
                                    )
                                  ) : form.getFieldValue(tabKey)[i]
                                    ?.brochureFileName ? (
                                    <>
                                      <a
                                        href={
                                          form.getFieldValue(tabKey)[i]
                                            .brochureFilePath || "#"
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <Button
                                          type="button"
                                          icon={<DownloadOutlined />}
                                        >
                                          {truncateFilename(
                                            form.getFieldValue(tabKey)[i]
                                              ?.brochureFileName
                                          )}
                                        </Button>
                                      </a>
                                      <Button
                                        icon={<DeleteOutlined />}
                                        onClick={() => {
                                          const brochureId =
                                            form.getFieldValue(tabKey)[i].id;
                                          if (brochureId)
                                            handleDeleteBrochure(brochureId);
                                        }}
                                      />
                                    </>
                                  ) : (
                                    "No file chosen"
                                  )}

                                  <label
                                    className="fileUploadBtn greenBtn"
                                    style={{ position: "relative" }}
                                  >
                                    {form.getFieldValue(tabKey)[i]
                                      ?.brochureFileName
                                      ? "Upload New Brochure"
                                      : "Upload Brochure"}

                                    <input
                                      type="file"
                                      accept="application/pdf"
                                      name={[name, "BrochureFile"]}
                                      onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        if (!file) return;

                                        // ✅ Validate MIME type and file extension
                                        const isPdf =
                                          file.type === "application/pdf" ||
                                          file.name
                                            .toLowerCase()
                                            .endsWith(".pdf");
                                        if (!isPdf) {
                                          message.error(
                                            "Only PDF files are allowed!"
                                          );
                                          e.target.value = ""; // reset input
                                          return;
                                        }

                                        // ✅ Validate file size (max 5MB)
                                        const maxSize = 5 * 1024 * 1024; // 5 MB
                                        if (file.size > maxSize) {
                                          message.error(
                                            "File size must be less than 5MB!"
                                          );
                                          e.target.value = ""; // reset input
                                          return;
                                        }

                                        // ✅ If valid, continue with existing logic
                                        updateFile(e, i, form, tabKey);
                                        setShowClear(true);
                                        setClearEnabled(true);
                                        setFormChanged(true);
                                      }}
                                    />

                                    <div
                                      className="remove-btn"
                                      style={{
                                        left: "initial",
                                        right: "-30px",
                                      }}
                                    >
                                      <Tooltip title="Only PDF files are allowed. Max size: 5MB.">
                                        <QuestionCircleOutlined />
                                      </Tooltip>
                                    </div>
                                  </label>
                                </Form.Item>
                              </div>

                              <Form.Item
                                className="w-100"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                {formChanged ? (
                                  <Button
                                    className="saveBtn greenBtn"
                                    onClick={() => {
                                      form.submit();
                                    }}
                                  >
                                    Save
                                  </Button>
                                ) : (
                                  <Button
                                    className="saveBtn greenBtn"
                                    style={{
                                      opacity: "0.5",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    Save
                                  </Button>
                                )}
                              </Form.Item>
                            </Col>

                            <Col className="gutter-row tabContent" span={8}>
                              <div>
                                {form.getFieldValue(whichTab)?.[i]
                                  ? renderMedia(form.getFieldValue(whichTab)[i]) // ✅ form state is always in sync
                                  : null}
                              </div>
                            </Col>
                          </div>
                        ))}
                      </>
                    )}
                  </Form.List>
                </>
              </Col>
            </>
          ) : (
            <></>
          )}
        </Row>
      </div>
    );
  }
}
